import { STATUS_ICON_LOADING } from '@/common/utils/statuses';
import createCommonModule from '@/common/store/modules/common';
import iscsiUpdater from '@/common/store/modules/iscsi/iscsiUpdater';
import waitTask from '@/common/utils/waitTask';
import { TaskState } from '@schema';
import { TaskName } from '@/common/constants/taskNames.constants';
import getClusterId from '@/common/store/pinia/storageCluster/getClusterId';

function resource() {
  return getClusterId()
    .then(clusterId => `/api/v2/${clusterId}/iscsi-alua/volumes/`);
}

export default createCommonModule({
  resource,
  plural: data => data,
  Model: Object,
  config: {
    needWaitTask: true
  },
  getters: {
    _mapItem: (state, getters, rootState, rootGetters) => (volumeId) => {
      const volume = state.itemsMap[volumeId];
      if (!volume) {
        return null;
      }

      const targetGroup = rootGetters['iscsi/targetGroups/getItemById'](volume.grp_id);

      let tgVolume;

      if (targetGroup) {
        tgVolume = targetGroup.volumes.find(vol => vol.id === volume.id);
      }

      return {
        ...volume,
        isAttachable: !targetGroup,
        isDeletable: !!volume.id && !targetGroup,
        isDetachable: volume.lun !== 0 || (volume.lun === 0 && targetGroup?.luns?.length === 1),
        statusIcon: volume.tasks?.length ? STATUS_ICON_LOADING : false,
        targetGroup,
        targetGroupId: volume.grp_id,
        lun: tgVolume?.lun,
        lunNum: tgVolume?.lun?.id
      };
    }
  },
  actions: {
    CREATE_VOLUME({ dispatch }, volume) {
      return dispatch('CREATE', {
        ...volume,
        size: Math.ceil(volume.size * (1024 ** 3))
      });
    },
    DELETE_ITEMS({ dispatch }, items) {
      return dispatch('DELETE_ITEMS_STEP_BY_STEP', items);
    },
    UPDATE_SIZE({ commit }, { id, size }) {
      return resource()
        .then(resourceStr => this.$api.put(`${resourceStr}/${id}`, {
          size: Math.ceil(size * (1024 ** 3))
        }))
        .then(waitTask)
        .then((task) => {
          commit('CLEAR_ERRORS');
          return task;
        })
        .catch((error) => {
          commit('SET_ERRORS', error);
          throw error;
        });
    },

    UPDATE_POLICY({ commit }, { id, policy }) {
      return resource()
        .then(resourceStr => this.$api.put(`${resourceStr}/${id}`, {
          volume_params: policy
        }))
        .then(waitTask)
        .then((task) => {
          commit('CLEAR_ERRORS');
          return task;
        })
        .catch((error) => {
          commit('SET_ERRORS', error);
          throw error;
        });
    },

    UPDATE_LIMITS({ commit }, { id, limits }) {
      return resource()
        .then(resourceStr => this.$api.put(`${resourceStr}/${id}`, {
          limits
        }))
        .then(waitTask)
        .then((task) => {
          commit('CLEAR_ERRORS');
          return task;
        })
        .catch((error) => {
          commit('SET_ERRORS', error);
          throw error;
        });
    },
    socket_tasks({ dispatch }, { name, state, result }) {
      const TASK_EVENT_NAMES = [
        TaskName.BLOCK_STORAGE_VOLUME_CHANGE,
        TaskName.BLOCK_STORAGE_VOLUME_DELETE,
        TaskName.BLOCK_STORAGE_VOLUME_CREATE,
      ];
      if (result && TASK_EVENT_NAMES.includes(name) && state === TaskState.SUCCESS) {
        if (result.id) {
          dispatch('FETCH_ITEM', { id: result.id });
        } else {
          dispatch('FETCH_ITEMS');
        }
        if (result.grp_id) {
          dispatch('iscsi/targetGroups/FETCH_ITEM', { id: result.grp_id }, { root: true });
        }
      }
    },
    ...iscsiUpdater('volumes')
  }
});
